import React from 'react';
import {
  TableHead,
  TableRow,
  TableSortLabel,
  Box, 
  Checkbox,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils'; 
import { ArrowDropDown as ArrowDropDownIcon, ArrowDropUp as ArrowUpwardIcon } from '@mui/icons-material';
import { StyledTableHeaderCell } from './styles';
import { CustomTableHeaderProps } from '@/interfaces';


const CustomTableHeader: React.FC<CustomTableHeaderProps> = ({
  columns,
  order,
  orderBy,
  onRequestSort,
  onSelectAllClick,
  numSelected,
  rowCount,
}) => {
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {onSelectAllClick && (
          <StyledTableHeaderCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected! > 0 && numSelected! < rowCount!}
              checked={rowCount! > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all shifts',
              }}
              sx={{ color: 'inherit' }}
            />
          </StyledTableHeaderCell>
        )}
        {columns.map((column) => (
          <StyledTableHeaderCell
            key={column.id}
            align='left'
            sortDirection={orderBy === column.id ? order : false}
          >
            {column.disableSorting ? (
              column.label
            ) : (
              <TableSortLabel
                active={orderBy === column.id}
                direction={orderBy === column.id ? order : 'asc'}
                onClick={createSortHandler(column.id)}
              >
                {column.label}
                {orderBy === column.id && order === 'desc' && <ArrowDropDownIcon sx={{ fontSize: '1.2rem', ml: 0.5 }} />}
                {orderBy === column.id && order === 'asc' && <ArrowUpwardIcon sx={{ fontSize: '1.2rem', ml: 0.5 }} />}
                {orderBy === column.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}
          </StyledTableHeaderCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomTableHeader;